import React from 'react';
import { unwrapRTEContent } from '../utils/helpers';
import Image from '../utils/image';

const ProductFeatures = (props) => {
  const { productFeatures } = props.product.metafields;

  if (!productFeatures || !productFeatures.length) return null;

  const featuresList = productFeatures.map((feature, i) => {
    if (i > 2) return null;
    return (
      <div
        className="flex items-center gap-6"
        key={`feature-${i}`}
      >
        <div className="shrink-0 grow-0 basis-10 [&>img]:size-10">
          {feature?.icon?.src ? (
            <Image
              src={feature.icon.src}
              height={80}
              width={80}
              alt={feature.icon?.altText}
            />
          ) : (
            <div className="size-10" />
          )}
        </div>

        <div
          className="rte [&>p]:body-2 [&>p>a]:body-2 [&>:first-child]:mt-0 [&>:last-child]:mb-0"
          dangerouslySetInnerHTML={{ __html: unwrapRTEContent(feature.description) }}
        ></div>
      </div>
    );
  });

  if (!productFeatures?.length) return null;
  return <div className="flex flex-col gap-4 rounded-md bg-brand-light-beige px-4 py-5">{featuresList}</div>;
};

export default ProductFeatures;
